import {injectElement} from './element';

const linkDom = 'link';
const styleDom = 'style';
const stylesheetDom = 'stylesheet';

export function injectStyle(path) {
  if (path) {
    const link = injectElement(linkDom);
    link.rel = stylesheetDom;
    link.href = path;
    document.head.appendChild(link);

    return link;
  }
}

export function injectStyleInline(css, id) {
  if (css) {
    const {head} = document;
    const current = document.getElementById(id);
    const style = current || injectElement(styleDom);
    style.textContent = css;

    if (!current) {
      style.id = id;
      head.appendChild(style);
    }

    return style;
  }
}
